module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/tables_en-90b3569643432562772851e69b1722ba.webp";